import React, { useEffect } from 'react';

import { Container } from '@material-ui/core';
import * as microsoftTeams from '@microsoft/teams-js';

const MSTeamLoginFinal = () => {
  useEffect(() => {
    microsoftTeams.authentication.notifySuccess({
      success: true,
    });
  }, []);

  return (
    <Container maxWidth="xs">
      <h1>You can close this window if it doesn't automatically and refresh the tab!</h1>
    </Container>
  );
};

export default MSTeamLoginFinal;
